"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_NOT_YET_SUPPORTED_MODAL = void 0;
exports.CREDIT_BUILDER_NOT_YET_SUPPORTED_MODAL = {
    HEADER: 'Credit Builder isn’t available at your property yet',
    LINE_1: 'We’re currently only offering Credit Builder to residents of select properties. If your property isn’t listed, that means we’re still working on adding it.',
    LINE_2: 'Stay tuned! We’ll contact you once Credit Builder becomes available to you.',
    CTA: 'Close'
};
